"use client";
import cn from "clsx";
import { Button, Flex, Tooltip } from "@radix-ui/themes";
import { fetchHost } from "@/util/fetchutil";
import { LayoutProps } from "@/components/layout/layoutType";
import { useTranslations } from "next-intl";
import { deleteCookie } from "@/util/cookies";
import { Debug } from "@/util/debug";
import { AlertContext } from "@/components/context/alertContext";
import { useContext } from "react";
import { clearIndexedDB } from "@/util/code";
import { alertLoading, setTimeoutDelay } from "../list/defaultType";
// import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { SocialLogin } from "@capgo/capacitor-social-login";
import { Capacitor } from "@capacitor/core";

import Icon from "@/components/common/icon/icon";
import Link from "next/link";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
export default function SignButton({ className, user, params }: { className?: string; user?: any | null; params?: LayoutProps }) {
  const ta = useTranslations("alert");
  const alertContext = useContext(AlertContext);

  const signOut = () => {
    const alert_p = alertContext.setProp; //params?.alertFunction;
    if (alert_p) {
      alert_p({
        open: true,
        title: ta("signout"),
        description: ta("signout_detail"),
        useCancel: true,
        useOk: true,
        okFunction: () => {
          setTimeout(() => {
            alert_p(alertLoading);
          }, 50);

          fetchHost(
            "/api/sign/signout",
            {
              mode: "cors",
              credentials: "include",
            },
            undefined,
            (data: any) => {
              if (data.status === "OK") {
                deleteCookie("g_state");
                // const auths: string[] = ["cafe", "roaster"];
                // auths.forEach(auth=>{
                // })
                if (sessionStorage) {
                  sessionStorage.clear();
                }
                clearIndexedDB(true);
                setTimeout(async () => {
                  if (Capacitor.getPlatform() != "web") {
                    // await GoogleAuth.signOut();
                    await SocialLogin.logout({ provider: "google" });
                    Debug("로그아웃 성공!");
                  }
                  if (location.pathname.indexOf("/user/signin") >= 0) {
                    location.href = "/";
                  } else {
                    location.reload();
                  }
                }, setTimeoutDelay);
              }
            },
            (e: any) => {
              Debug(e);
            },
          );
        },
      });
    }
  };
  const signIn = () => {
    location.href = "/user/signin";
  };
  const iconName = user != null ? "SignOut" : "SignIn";
  const SignButtonClick = user != null ? signOut : signIn;
  const title = user != null ? user.name : ta("signin");

  return (
    <Flex direction="column" className={cn(className, "overflow-hidden")}>
      <Button
        color="gray"
        variant="ghost"
        className="outline-0 cursor-pointer group hover:bg-transparent"
        id="tool_sign_button"
        aria-label="Tool Sign Button"
        onClick={SignButtonClick}
      >
        <Tooltip content={title}>
          <Flex align="center" gap="2" className="p-1 ">
            <Icon
              iconType="phosphor"
              iconName={iconName}
              className={cn("w-5 h-5", "group-hover:animate-rotate-y group-hover:animate-reverse animate-fill-backwards")}
            />
          </Flex>
          {/* {user != null ? (
          ) : (
            <Link href={"/user/signin"} prefetch={false} style={{ textDecoration: "inherit", color: "inherit" }}>
              <Flex align="center" gap="2" className="p-1 ">
                <Icon
                  iconType="phosphor"
                  iconName={iconName}
                  className={cn("w-5 h-5", "group-hover:animate-rotate-y group-hover:animate-reverse animate-fill-backwards")}
                />
              </Flex>
            </Link>
          )} */}
        </Tooltip>
      </Button>
    </Flex>
  );
}
